const TOKEN_KEY = "token"
const USER_KEY = "user"
const EXPIRES_KEY = "expiresAt"
const LAST_ACTIVITY_KEY = "lastActivity"

const IDLE_LIMIT = 15 * 60 * 1000 // 15 minutes

export const auth = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY)
  },

  setToken(token, expiresAt) {
    localStorage.setItem(TOKEN_KEY, token)
    localStorage.setItem(EXPIRES_KEY, expiresAt)
    this.updateActivity()
    window.dispatchEvent(new Event("auth:changed"))
  },

  setUser(user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user))
    window.dispatchEvent(new Event("auth:changed"))
  },

  getUser() {
    const raw = localStorage.getItem(USER_KEY)
    return raw ? JSON.parse(raw) : null
  },

  updateActivity() {
    localStorage.setItem(LAST_ACTIVITY_KEY, Date.now())
  },

  isAuthenticated() {
    const token = localStorage.getItem(TOKEN_KEY)
    const expiresAt = localStorage.getItem(EXPIRES_KEY)
    const lastActivity = localStorage.getItem(LAST_ACTIVITY_KEY)

    if (!token || !expiresAt || !lastActivity) return false

    // ⛔ inactivity logout
    if (Date.now() - Number(lastActivity) > IDLE_LIMIT) {
      this.logout()
      return false
    }

    // ⛔ token expired
    if (Date.now() > Number(expiresAt)) {
      this.logout()
      return false
    }

    return true
  },

  logout() {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
    localStorage.removeItem(EXPIRES_KEY)
    localStorage.removeItem(LAST_ACTIVITY_KEY)

    window.dispatchEvent(new Event("auth:changed"))
  },
}
